export const gateAccountCategory = 'gate'

export const networkEvmChainIds: Record<string, number | undefined> = {
  ARBEVM: 42161,
  ARBNOVA: 42170,
  ASTREVM: 592,
  AVAX_C: 43114,
  BASEEVM: 8453,
  BERA: 80094,
  BLASTETH: 81457,
  BSC: 56,
  ETH: 1,
  FTM: 250,
  GLMR: 1284,
  LINEAETH: 59144,
  MANTAETH: 169,
  MATIC: 137,
  METIS: 1088,
  MNT: 5000,
  MOVR: 1285,
  OAS: 248,
  OPETH: 10,
  RON: 2020,
  S: 146,
  SCROLLETH: 534352,
  TAIKOETH: 167000,
  ZKSERA: 324,
}

export const networkPolkadotChainIds: Record<string, number | undefined> = {
  ASTR: 2006,
  DOT: 0,
  DOTSM: 1000,
  MANTADOT: 2104,
}

export const solanaNetwork = 'SOL'
